const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/grid-plans', {
  title: 'Grid plans Sumicity',
  description: 'Esse componente deverá ser usado apenas dentro componente "Streaming Planos Detalhes"',
  icon: 'admin-site',
  category: 'design',
  attributes,

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
